var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('section',[_c('div',{staticClass:"title font-weight-bold black--text",staticStyle:{"opacity":"70%"}},[_vm._v("\n      #Keluarga Sentana\n    ")]),_c('div',[_c('tables',{attrs:{"config":_vm.config()}})],1)])])
}
var staticRenderFns = []

export { render, staticRenderFns }